var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signup__form" },
    [
      _vm.dtMode === "validation"
        ? _c(
            "v-form",
            {
              ref: "validationFormRef",
              model: {
                value: _vm.dtForm,
                callback: function($$v) {
                  _vm.dtForm = $$v
                },
                expression: "dtForm"
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.blockCode))
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "blockCodeRef",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t(_vm.lblSetting.blockCode)
                    },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.handleValidate($event)
                      }
                    },
                    model: {
                      value: _vm.dtBlockCode,
                      callback: function($$v) {
                        _vm.dtBlockCode = $$v
                      },
                      expression: "dtBlockCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "login--button",
                  attrs: {
                    color: "turquoise",
                    block: "",
                    loading: _vm.dtIsLoading
                  },
                  on: { click: _vm.handleValidate }
                },
                [
                  _c(
                    "span",
                    { staticClass: "login--button-text primary--text" },
                    [_vm._v(_vm._s(_vm.$t("BTN_VALIDATE")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "login-text" }, [
                _vm._v("Vous avez un compte?\n      "),
                _c(
                  "a",
                  {
                    staticClass: "login--signup",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function($event) {
                        _vm.$router.push("/")
                      }
                    }
                  },
                  [_vm._v("\n        S'identifier!\n      ")]
                )
              ])
            ],
            1
          )
        : _c(
            "v-form",
            {
              ref: "registrationFormRef",
              model: {
                value: _vm.dtRegistrationForm,
                callback: function($$v) {
                  _vm.dtRegistrationForm = $$v
                },
                expression: "dtRegistrationForm"
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.civ))
                    }
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "ma-0 pa-0",
                    attrs: { items: _vm.civilities },
                    model: {
                      value: _vm.dtUserInfo.civility,
                      callback: function($$v) {
                        _vm.$set(_vm.dtUserInfo, "civility", $$v)
                      },
                      expression: "dtUserInfo.civility"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.firstname))
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "firstnameRef",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t(_vm.lblSetting.placeholder, {
                        field: _vm.$t(_vm.lblSetting.firstname)
                      })
                    },
                    model: {
                      value: _vm.dtUserInfo.firstname,
                      callback: function($$v) {
                        _vm.$set(_vm.dtUserInfo, "firstname", $$v)
                      },
                      expression: "dtUserInfo.firstname"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.lastname))
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t(_vm.lblSetting.placeholder, {
                        field: _vm.$t(_vm.lblSetting.lastname)
                      })
                    },
                    model: {
                      value: _vm.dtUserInfo.lastname,
                      callback: function($$v) {
                        _vm.$set(_vm.dtUserInfo, "lastname", $$v)
                      },
                      expression: "dtUserInfo.lastname"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.email))
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      type: "email",
                      rules: [_vm.rules.require, _vm.rules.email],
                      placeholder: _vm.$t(_vm.lblSetting.placeholder, {
                        field: _vm.$t(_vm.lblSetting.email)
                      })
                    },
                    model: {
                      value: _vm.dtUserInfo.email,
                      callback: function($$v) {
                        _vm.$set(_vm.dtUserInfo, "email", $$v)
                      },
                      expression: "dtUserInfo.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.password))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-text-field",
                    {
                      attrs: {
                        type: _vm.dtPasswordMode,
                        rules: [_vm.rules.require],
                        placeholder: _vm.$t(_vm.lblSetting.placeholder, {
                          field: _vm.$t(_vm.lblSetting.password)
                        })
                      },
                      model: {
                        value: _vm.dtUserInfo.password,
                        callback: function($$v) {
                          _vm.$set(_vm.dtUserInfo, "password", $$v)
                        },
                        expression: "dtUserInfo.password"
                      }
                    },
                    [
                      _vm.dtUserInfo.password
                        ? _c("template", { slot: "append" }, [
                            _c(
                              "a",
                              {
                                staticClass: "login--no-decoration",
                                attrs: { href: "javascript:void(0);" },
                                on: { click: _vm.handleShowPassword }
                              },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.mobilePhone))
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      type: "text",
                      rules: [_vm.rules.require],
                      placeholder: _vm.$t(_vm.lblSetting.placeholder, {
                        field: _vm.$t(_vm.lblSetting.mobilePhone)
                      })
                    },
                    model: {
                      value: _vm.dtUserInfo.cellphone,
                      callback: function($$v) {
                        _vm.$set(_vm.dtUserInfo, "cellphone", $$v)
                      },
                      expression: "dtUserInfo.cellphone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-left" },
                [
                  _c("label", {
                    staticClass: "primary--text text-uppercase login--label",
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.profile))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-radio-group",
                    {
                      staticClass: "mt-0",
                      attrs: { mandatory: false, "hide-details": "" },
                      model: {
                        value: _vm.dtUserInfo.fk_user_role,
                        callback: function($$v) {
                          _vm.$set(_vm.dtUserInfo, "fk_user_role", $$v)
                        },
                        expression: "dtUserInfo.fk_user_role"
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        _vm._l(_vm.agencyInfo.sign_up_roles, function(role) {
                          return _c(
                            "v-flex",
                            { key: role.id, attrs: { xs6: "" } },
                            [
                              _c("v-radio", {
                                attrs: { label: role.name, value: role.id }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "login--button",
                  attrs: {
                    color: "turquoise",
                    block: "",
                    loading: _vm.dtIsLoading
                  },
                  on: { click: _vm.handleRegister }
                },
                [
                  _c(
                    "span",
                    { staticClass: "login--button-text primary--text" },
                    [_vm._v(_vm._s(_vm.$t("BTN_VALIDATE")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "login--signup",
                    staticStyle: { float: "left" },
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function($event) {
                        _vm.dtMode = "validation"
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t(_vm.lblSetting.back)) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "login-text text-xs-right" }, [
                  _vm._v("Vous avez un compte?\n        "),
                  _c(
                    "a",
                    {
                      staticClass: "login--signup",
                      attrs: { href: "javascript:void(0);" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/")
                        }
                      }
                    },
                    [_vm._v("\n          S'identifier!\n        ")]
                  )
                ])
              ])
            ],
            1
          ),
      _vm._v(" "),
      _vm.dtError
        ? _c(
            "v-alert",
            {
              staticStyle: { "margin-top": "5%", width: "45vh" },
              attrs: {
                value: true,
                color: "error",
                icon: "warning",
                outline: ""
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.dtError.message) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dtRegisteredSuccess,
            callback: function($$v) {
              _vm.dtRegisteredSuccess = $$v
            },
            expression: "dtRegisteredSuccess"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(_vm.lblSetting.lblMessage, {
                      email: _vm.dtUserInfo.email
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: { click: _vm.handleRergisteredSucess }
                    },
                    [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.lblConfirmButton)))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c8e63ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c8e63ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/signup/template.html
// module id = null
// module chunks = 